import { useState, useEffect } from "react";
import { apiClient } from "../apiClient";

export function useSubmissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubmissions = async () => {
    try {
      setLoading(true);
      const data = await apiClient.getSubmissions();
      setSubmissions(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching submissions:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const createSubmission = async (submission) => {
    try {
      const newSubmission = await apiClient.createSubmission(submission);
      // Refresh submissions after creating a new one
      await fetchSubmissions();
      return { data: newSubmission, error: null };
    } catch (err) {
      console.error("Error creating submission:", err);
      return { data: null, error: { message: err.message } };
    }
  };

  return { 
    submissions, 
    loading, 
    error, 
    createSubmission,
    refetch: fetchSubmissions 
  };
}
